import styled, { css } from 'styled-components';
import { media, remCalc, layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import Dropdown from '@prisjakt/ui-dropdown';
import AdContainerComponent from '../../../../components/ads';

type AdvertProps = {
  withPosition?: boolean;
};

const compensateForPadding = remCalc(layout.gridColumnGutter.small.value / 2);

export const AdContainer = styled(AdContainerComponent)`
  @media screen and (max-width: 340px) {
    margin-left: -${compensateForPadding};
    margin-right: -${compensateForPadding};
  }
`;

export const Placeholder = styled.div`
  background: ${p => p.theme.placeholders.bg};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${layout.measurements.spacingMedium};
`;

export const PlaceholderTitle = styled.span`
  font-size: ${layout.measurements.fontSizeMedium};
  font-weight: 600;
`;

export const PlaceholderCategory = styled.span`
  margin-top: ${layout.measurements.spacingNormal};
`;

export const PlaceholderLink = styled(Clickable)`
  margin-bottom: ${layout.measurements.spacingSmall};
  color: ${p => p.theme.text.callToAction};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;

export const Information = styled.div`
  border-top: 1px solid ${p => p.theme.colors.base200};
  color: ${p => p.theme.colors.base500};
  font-size: ${remCalc(13)};
  font-style: italic;
  padding-top: ${remCalc(10)};
  padding-bottom: ${remCalc(10)};
`;

export const AdvertTableRowElement = styled.div<AdvertProps>`
  width: 100%;
  border-bottom: none;

  ${p =>
    p.withPosition &&
    css`
      order: 3;
    `};
`;

export const PriceFilter = styled(Dropdown)`
  /* Merge dropdown border with the divider when expanded */
  margin-left: -1px;

  &.ui-dropdown {
    &-expanded {
      .ui-dropdown--header {
        margin-bottom: -1px;
        border-bottom: 1px solid ${p => p.theme.colors.base0};
        /* Have to end up on top of the content */
        z-index: 2;
      }
    }

    .ui-dropdown--sub-content {
      padding-top: ${remCalc(10)};
      padding-bottom: ${remCalc(10)};
      width: 200px;
      right: 0;
      border-top: 1px solid ${p => p.theme.colors.base300};
    }

    /* On mobile, we only want the three vertical dots, not the arrow. */
    ${media.smallOnly`
        .pj-ui-icon--arrow {
          display: none;
        }
  `}
  }

  /* Style the dropdown toggle as 'selected'.
    Not a good way to achieve this, but necessary until
    we refactor the Dropdown component. */
  .ui-dropdown--toggle-button,
  .ui-dropdown--title-expanded {
    color: ${p => p.theme.text.callToAction};
    font-weight: 600;

    &:hover {
      color: ${p => p.theme.text.callToActionHover};

      .ui-dropdown--title-expanded {
        color: ${p => p.theme.text.callToActionHover};
      }

      svg path {
        fill: ${p => p.theme.icons.callToActionHover};
      }
    }
  }
`;

export const PricePanelHeader = styled.span(
  props => css`
    display: flex;
    align-items: center;
    text-transform: none;
    white-space: nowrap;

    ${media.smallOnly`
      display: none;
  `}
  `
);

export const TitleCount = styled.span`
  font-weight: 100;
  font-size: ${layout.measurements.fontSizeSmall};
  margin-left: ${layout.spacing.xxSmall};
`;

export const Header = styled.div`
  align-items: center;
  position: relative;
  z-index: 3; /* Needed for sorting dropdown */
  margin-top: ${layout.measurements.spacingNormal};
  margin-bottom: ${layout.measurements.spacingSmall};

  ${media.smallOnly`
    margin: ${layout.measurements.spacingSmall} 0 ${layout.measurements.spacingTiny} 0;
    grid-template-columns: repeat(2, 1fr);
  `};
`;

export const HeaderButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, min-content);
  justify-content: space-between;
  gap: ${layout.measurements.spacingTiny};
  margin-bottom: ${layout.measurements.spacingSmall};
`;

export const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, min-content);
  justify-content: space-between;
  align-items: center;
  gap: ${layout.measurements.spacingTiny};

  ${media.smallOnly`
    grid-template-columns: repeat(2, 1fr);
  `};
`;

export const DisclaimerWrapper = styled.div`
  ${media.smallOnly`
    position: absolute;
    width: calc(100vw - ${remCalc(layout.pageContent.gutter.value * 2)});
  `}
`;
